import React from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import { connect } from "react-redux";
import { Row, Col } from "react-bootstrap";
import {
  form,
  Form as AppForm,
  NumberInput,
  Select,
  TextArea
} from "MODULES/shared/components/Forms";
import { toOptions } from "LIB/forms";
import { CONDITION, SUGGESTED_RETAIL } from "MODULES/inventories/constants";
import { properCase } from "LIB/formatters/text";
import { NOTE } from "MODULES/shared/constants";
import { QUANTITY } from "APP_ROOT/constants";
import validate from "./validate";
import { CONDITION_TYPES } from "./constants";

function Form(props) {
  return (
    <AppForm {...props}>
      <AppForm.Body>
        <Row>
          <Col md={4}>
            <Field
              name={QUANTITY}
              label="QTY"
              component={NumberInput}
              roundDigits={0}
              inputProps={{ min: 0 }}
              required
            />
          </Col>
          <Col md={4}>
            <Field
              name={CONDITION}
              component={Select}
              options={toOptions(CONDITION_TYPES)}
              label={properCase(CONDITION)}
              required
            />
          </Col>
          <Col md={4}>
            <Field
              label="SRP"
              name={SUGGESTED_RETAIL}
              component={NumberInput}
              roundDigits={0}
              inputProps={{ min: 0 }}
              required
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Field
              name={NOTE}
              component={TextArea}
              label={properCase(NOTE)}
              rows="5"
            />
          </Col>
        </Row>
      </AppForm.Body>
    </AppForm>
  );
}

Form.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired
};

export default connect(undefined, (dispatch, ownProps) => ({
  onSubmit: data => dispatch(ownProps.submitAction(data))
}))(
  form({
    form: "dummyInventory",
    validate
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/inventories/components/Detail/Dummies/Form.jsx